/**
 * dedede
 * @packageDocumentation
 * @module promises/retry
 */
/**
 * Generates a Backoff function with a linear backoff strategy.
 *
 * @param seconds - The number of seconds to wait
 * @returns The backoff getter function
 */
export const linearRetryBackoff = (seconds) => (currentTry) => currentTry * seconds * 1000;
/**
 * Generates a Backoff function with a constant backoff.
 *
 * @param seconds - The number of seconds to wait
 * @returns The backoff getter function
 */
export const constantRetryBackoff = (seconds) => () => seconds * 1000;
/**
 * Generates a Backoff function with a exponential backoff strategy.
 *
 * @param seconds - The base number of seconds to wait
 * @returns The backoff getter function
 */
export const exponentialRetryBackoff = (seconds) => (currentTry) => 2 ** currentTry * seconds * 1000;
